import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { FormGroup, Input, Button } from '../components/ui'
import { getSafeLoginNext } from '../utils/loginRedirect'
import './Login.css'

function Login() {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login: loginUser } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const result = await loginUser(login, password)
    
    if (result.success) {
      const next = getSafeLoginNext(searchParams)
      if (next) {
        navigate(next, { replace: true })
        return
      }
      if (result.user?.employee_full_name) {
        navigate(`/company/team/${encodeURIComponent(result.user.employee_id || result.user.employee_full_name)}`)
      } else {
        navigate('/company/team')
      }
    } else {
      setError(result.error)
    }
    
    setLoading(false)
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <img src="/logo/logo.png" alt="2ПБ" className="login-logo-image" onError={(e) => { e.target.src = '/logo/logo.jpg'; }} />
            <div className="login-logo-text">
              <div className="login-logo-text-line1">ПРОЕКТНАЯ</div>
              <div className="login-logo-text-line2">АРТЕЛЬ</div>
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          <FormGroup label="Логин" htmlFor="login">
            <Input
              id="login"
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              required
              autoFocus
            />
          </FormGroup>
          <FormGroup label="Пароль" htmlFor="password">
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FormGroup>
          <Button type="submit" variant="outline" disabled={loading}>
            {loading ? 'ВХОД...' : 'ВОЙТИ'}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default Login

